import { Box, Heading, Text } from '@chakra-ui/react';

interface OnboardingHeadingProps {
  title: string;
  subtitle?: string;
  /** The welcome page sets its title a size up (mock-up). */
  size?: 'md' | 'lg';
}

/**
 * Shared title + subtitle block for the left form pane of the onboarding split
 * layout: the mock-up's editorial heading (Figtree) over a light Geist subtext.
 * Progress and motion wrapper are owned by `OnboardingLayout`.
 */
export const OnboardingHeading = ({ title, subtitle, size = 'md' }: OnboardingHeadingProps) => (
  <Box>
    <Heading
      as="h1"
      fontFamily="heading"
      fontSize={size === 'lg' ? '32px' : { base: '26px', md: '30px' }}
      fontWeight="600"
      letterSpacing="-0.02em"
      lineHeight="1.12"
      color="ink"
    >
      {title}
    </Heading>
    {subtitle && (
      <Text
        fontFamily="body"
        fontSize="15px"
        color="inkMuted"
        mt="10px"
        lineHeight="1.5"
        fontWeight="300"
      >
        {subtitle}
      </Text>
    )}
  </Box>
);
